module.exports = __webpack_public_path__ + "img/deflogo.b69981f7.png";